import * as React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import AddMoney from './childScreens/addMoney';
import WithdrawMoney from './childScreens/withDrawMoney';
import Transaction from './childScreens/Transaction';
import KYC from './childScreens/Kyc';
import WalletTxnStatus from './childComponents/WalletTxnStatus';
import TransactionScreen from "./childScreens/TransactionScreen";
import WalletAmountReview from "./childScreens/WalletAmountReview";

const Stack = createNativeStackNavigator();

export const WalletStack = ({ storeData }) => {
  return (
    <Stack.Navigator
      screenOptions={({ route, navigation }) => ({
        headerShown: false,
        gestureEnabled: true,
      })}
    >
      <Stack.Screen name="WalletAdd" component={AddMoney} />
      <Stack.Screen name="WalletWithdraw" component={WithdrawMoney} />
      <Stack.Screen name="Transaction" component={Transaction} />
      <Stack.Screen name="TransactionScreen" component={TransactionScreen} />
      <Stack.Screen name="Kyc" component={KYC} />
      <Stack.Screen name="WalletStatus" component={WalletTxnStatus} />
      <Stack.Screen name="WalletAmountReview" component={WalletAmountReview} />
    </Stack.Navigator>
  );
};
